export const SILENT_ERROR_HEADER = 'X-Silent-Error';
